var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { RadioButtonDesignStyles } from '../../../../atoms/radio-button';
import { Text, TextHtmlTags, TextVariants } from '../../../../atoms/text';
import { RadioGroup, RadioGroupOrientations } from '../../../../molecules/radio-group';
var Sorting = function (_a) {
    var title = _a.title, ariaLabelProp = _a["aria-label"], id = _a.id, name = _a.name, _b = _a.value, valueProp = _b === void 0 ? '' : _b, _c = _a.radioButtons, radioButtonsProp = _c === void 0 ? [] : _c, required = _a.required, errorProp = _a.error, _d = _a.row, row = _d === void 0 ? RadioGroupOrientations.Vertical : _d, message = _a.message, onChangeProp = _a.onChange;
    var _e = useState(valueProp), value = _e[0], setValue = _e[1];
    var error = useMemo(function () { return errorProp || radioButtonsProp.some(function (r) { return r === null || r === void 0 ? void 0 : r.error; }); }, [errorProp, radioButtonsProp]);
    var radioButtons = useMemo(function () {
        return radioButtonsProp.map(function (_a) {
            var label = _a.label, radioValue = _a.value, checked = _a.checked, rest = __rest(_a, ["label", "value", "checked"]);
            return (__assign({ label: (React.createElement(Text, { component: TextHtmlTags.Span, isHtml: true, variant: TextVariants.Body1, content: "".concat(label) })), value: radioValue, checked: value ? value === radioValue : checked }, rest));
        });
    }, [radioButtonsProp, value]);
    var onChange = useCallback(function (e) {
        var currentValue = e.target.value;
        e.preventDefault();
        setValue(currentValue);
        onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(e, currentValue);
    }, [onChangeProp]);
    useEffect(function () {
        setValue(valueProp);
    }, [valueProp]);
    return (React.createElement(RadioGroup, { title: (React.createElement(Text, { component: TextHtmlTags.Span, variant: TextVariants.H6, content: title })), id: id, name: name, value: value, required: required, radioButtons: radioButtons, row: row, errorHint: error ? message : '', designStyle: RadioButtonDesignStyles.Standard, "aria-label": ariaLabelProp || title, onChange: onChange }));
};
export { Sorting };
